<script setup>
import { APP } from "@/config/app";
import { handleSignOut } from "@/utils/cognito";
import { useRoute, useRouter } from "vue-router";
import useNavigationLinks from "../hooks/useNavigationLinks";

const props = defineProps({
  type: {
    type: String,
    required: false,
    default: "SELF_SELECT"
  },
  clientInfo: {
    type: Object,
    required: false,
  },
  hasSelfSelectPortfolio: {
    type: Boolean,
    required: true,
    default: false
  },
  corporateClientServices: {
    type: Object,
    required: true
  },
  killSwitchFlags: {
    type: Object,
    required: true
  },
  currentPage: {
    type: String,
    required: false
  },
  isAuthenticated: {
    type: Boolean,
    required: true
  },
  mobileMenuOpen: {
    type: Boolean,
    required: true
  }
});

// const mobileMenuOpen = defineModel("mobileMenuOpen"); // Bind to parent ref
const emit = defineEmits(['update:mobileMenuOpen'])

const authenticatedLinks = useNavigationLinks({
    type: props.type,
    clientInfo: props.clientInfo,
    killSwitchFlags: props.killSwitchFlags,
    hasSelfSelectPortfolio: props.hasSelfSelectPortfolio,
    corporateClientServices: props.corporateClientServices,
});

const route = useRoute();
const router = useRouter();

async function logout() {
  await handleSignOut();
  window.location.reload();
}

</script>

<template>
  <div v-if="!props.killSwitchFlags.getAppDisabled">
    <div class="mx-auto px-8">
      <div class="flex flex-col gap-4 sm:gap-x-12">
        <RouterLink
          v-for="item in authenticatedLinks"
          :key="item.name"
          :to="item.href"
          @click="emit('update:mobileMenuOpen', false)"
          class="body-2-light text-off-black sub-nav-link"
        >
          <span v-html="item.html ?? undefined"></span>
          {{ item?.html == null ? item.name : '' }}
        </RouterLink>
        <RouterLink
          v-if="isAuthenticated"
          @click="logout()"
          :to="'/login'"
          :class="[APP.MyWealthMode ? 'secondary-mwp' : 'secondary-mwi', 'button-padding body-3-semi-bold rounded-full max-w-max flex']"
          aria-label="Log out"
        >
          Log out
        </RouterLink>
      </div>
    </div>
  </div>
</template>
